import CouponAll from "pages/CouponAll";
import CouponDetail from "pages/CouponDetail";
import CouponQr from "pages/CouponQr";
import CustomerQr from "pages/CustomerQr";
import HistoryPoint from "pages/HistoryPoint";
import LineDeepLink from "pages/LineDeepLink";
import PolicyEn from "pages/PolicyEn";
import PolicyTH from "pages/PolicyTH";
import Profile from "pages/Profile";
import ProfileEdit from "pages/ProfileEdit";
import Register from "pages/Register";
import RegisterComplete from "pages/RegisterComplete";
import RegisterOtp from "pages/RegisterOtp";
import RestaurantAll from "pages/RestaurantAll";
import Verified from "pages/Verified";
import VerifiedComplete from "pages/VerifiedComplete";
import VerifiedForm from "pages/VerifiedForm";
import VerifiedOtp from "pages/VerifiedOtp";
import Welcome from "pages/Welcome";
import PromotionDetail from "pages/PromotionDetail";
import React, {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";



const appRouter = (props) => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Welcome />} />
        <Route path="/welcome" element={<Welcome />} />
        <Route path="/register" element={<Register />} />
        <Route path="/register-otp" element={<RegisterOtp />} />
        <Route path="/register-complete" element={<RegisterComplete />} />
        <Route path="/verified" element={<Verified />} />
        <Route path="/verified-otp" element={<VerifiedOtp />} />
        <Route path="/verified-form" element={<VerifiedForm />} />
        <Route path="/verified-complete" element={<VerifiedComplete />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/customer-qr" element={<CustomerQr />} />
        <Route path="/profile-edit" element={<ProfileEdit />} />
        <Route path="/coupon-all" element={<CouponAll />} />
        <Route path="/coupon-detail" element={<CouponDetail />} />
        <Route path="/restaurant-all" element={<RestaurantAll />} />
        <Route path="/coupon-qr" element={<CouponQr />} />
        <Route path="/deep-link" element={<LineDeepLink/>} />
        <Route path="/policy-en" element={<PolicyEn />} />
        <Route path="/policy-th" element={<PolicyTH />} />
        <Route path="/history-point" element={<HistoryPoint />} />
        <Route path="/promotion-detail" element={<PromotionDetail />} />
      </Routes>
    </Router>
  );
};

export default appRouter;